export interface GuestIdentity {
  name: string
  email: string
}

const GUEST_IDENTITY_PREFIX = 'kc3-client-guest-identity:'

function guestIdentityKey(tenantSlug: string): string {
  return `${GUEST_IDENTITY_PREFIX}${tenantSlug}`
}

export function loadGuestIdentity(tenantSlug: string): GuestIdentity | null {
  try {
    const raw = localStorage.getItem(guestIdentityKey(tenantSlug))
    if (!raw) return null
    const parsed = JSON.parse(raw) as unknown
    const { name, email } = parsed as { name?: unknown; email?: unknown }
    if (typeof name === 'string' && typeof email === 'string' && name && email) {
      return { name, email }
    }
  } catch {
    // ignore
  }
  return null
}

export function saveGuestIdentity(tenantSlug: string, identity: GuestIdentity): void {
  try {
    localStorage.setItem(guestIdentityKey(tenantSlug), JSON.stringify(identity))
  } catch {
    // ignore
  }
}
